// 处理多维数组降一维
export function parseArr (arr) {
  let res = []
  arr.forEach((item)=>{
    res = (item instanceof Array) ? [...res, ...parseArr(item)] : [...res, item]
  })
  return res
} 

export function getRoutes (menuList) {
  const noChildren = menuList.filter(item=>{
    return !item.children
  })
  const hasChildren = menuList.filter(item=>{
    return item.children
  })
  const child = hasChildren.map(item=>{
    return getRoutes(item.children)
  })
  const path = noChildren.map(item=>{
    return { ...item }
  })
  
  return [...path, ...child]
}

// 侧栏不展示但保留 menu 配置项（hiddenInNav: true）
function stripHiddenMenuItems (list) {
  if (!(list instanceof Array)) {
    return []
  }
  const out = []
  for (const item of list) {
    if (item.hiddenInNav) {
      continue
    }
    if (item.children && item.children.length) {
      const children = stripHiddenMenuItems(item.children)
      if (children.length === 0) {
        continue
      }
      out.push({ ...item, children })
    } else {
      out.push(item)
    }
  }
  return out
}

// 根据权限筛选Menu
export function filterMenu (list = [], configs = [], listName = 'menuList') {
  const Node = []
  if (!(list instanceof Array)) {
    console.error(`${listName}并不是一个数组类型`)
  }
  list = stripHiddenMenuItems(list)
  if (configs.length === 0) {
    return list
  }
  list.forEach(item => {
    if (item.children) {
      const filteredChildren = filterMenu(item.children, configs, `key值为-${item.key}的children`)
      if (filteredChildren.length > 0) {
        Node.push({ ...item, children: filteredChildren })
      }
    } else {
      if (configs.includes(item.key)) {
        Node.push(item)
      }
    }
  })
  return Node
}

// 判断是否为有值得对象
export function isObject (obj) {
  if (!obj) {
    return false
  }
  const keyArr = Object.keys(obj)
  // console.log(keyArr)
  if (keyArr.length > 0) {
    return true
  }
  else {
    return false
  }
}

// 判断对象数组
export function isObjArr (value) {
  if (Object.prototype.toString.call(value) === '[object Array]') {
    return 'arr'
  } else if (Object.prototype.toString.call(value)==='[object Object]') {
    return 'obj'
  } else {
    return false
  }
}


// #region getQueryString 获取请求参数
export const getQueryString = (key) => {
  // key = key.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
  var regex = new RegExp('[\\?&]' + key + '=([^&#]*)', 'i'),
    results = regex.exec(window.location.search)
  return results == null ? '' : decodeURIComponent(results[1])
}
// #endregion


export function getCardTypeName (CardType) {
  switch (CardType) {
  case 1:
    return '身份证'
  case 2:
    return '军官证'
  case 3:
    return '通行证'
  case 4:
    return '护照'
  case 5:
    return '回乡证'
  default:
    return ''
  }
}

export function getOrderStatusName (status) {
  let statusName
  switch (status) {
  case 20:
    statusName = '已取消'
    break
  case 40:
    statusName = '退款申请中'
    break
  case 44:
  case 45:
    statusName = '已退款'
    break
  default:
    statusName = '已取消'
    break
  }
  return statusName
}
